import { Component, Inject, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogCloseEvent } from '../../../const';
import { SectorService } from '../sector.service';
import { FormControl, Validators } from '@angular/forms';
import { DtoSector } from '../../../models/sector.model';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-create-sector',
  templateUrl: './create-sector.component.html'
})
export class CreateSectorComponent {
 
  sectorName = new FormControl('', [
    Validators.required,
    Validators.pattern("^.*[a-zA-Z]+.*$ ?") //Should have atleast on alphabet
  ])

  constructor( public dialog: MatDialog, private sectorService: SectorService,
    @Optional() public dialogRef: MatDialogRef<CreateSectorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private toasterService: ToastrService ) {}
 
  cancel(){
    this.dialogRef.close({event: MatDialogCloseEvent.CANCELLED});
  }

  createSector(){
    let payload: DtoSector = {
      sectorId : 0,
      sectorName: this.sectorName.value
    } as DtoSector
    this.sectorService.createSector(payload).subscribe((response: any)=>{
      if(response){
        this.toasterService.success('Sector created successfully', 'Success');
        this.dialogRef.close({event:MatDialogCloseEvent.SUCCESS});
      }
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }
}
